import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import axios from 'axios';
import Table from '../../components/Table';
import { API_HOST } from '../../consts';
import Loading from '../../components/Loading';
import Link from 'react-router-dom/es/Link';
import { get } from 'lodash';
import FormTable from '../../components/FormTable';
import * as XLSX from 'xlsx';

export default class GabaritoModal extends React.Component {
  state = {
    data: [],
    quantitativoData: [],
    pageSize: this.defaultPageSize,
    metadata: {}
  };
  metadataModels = ['matriz'];

  onOpened = () => {
    if (this.shouldFetchData) {
      this.shouldFetchData = false;
      this.fetchData();
      this.fetchQuatitativo();
      this.fetchMetadata();
    }
  };

  fetchMetadata() {
    this.setState({ fetchingMetadata: true });
    return axios
      .get(`${API_HOST}/params/param?model=${this.metadataModels.join('|')}`)
      .then((response) => {
        this.setState({
          metadata: this.mapMetadata(response.data),
          fetchingMetadata: false
        });
      });
  }

  mapMetadata(metadata) {
    const mapped = {};
    metadata &&
      metadata
        .filter((d) => d.is_active === true)
        .forEach((m) => {
          mapped[`${m.model}.${m.name}`] = m.default;
        });
    return mapped;
  }

  shouldDisplayDefault(field) {
    const { metadata } = this.state;
    return get(metadata, field);
  }

  getPageSize(data) {
    if (data.length === 0) {
      return 1;
    }

    if (data.length < this.defaultPageSize) {
      return data.length;
    }

    return this.defaultPageSize;
  }

  shouldFetchData = true;
  defaultPageSize = 20;
  headersAlternativa = ['Letra', 'Quantidade', 'Porcentagem'];

  fetchData() {
    this.setState({ fetchingData: true });
    const { avaliacao } = this.props;

    axios
      .get(`${API_HOST}/avaliacoes/avaliacao/${avaliacao}/gabarito`)
      .then((response) => {
        this.setState({
          data: response.data,
          fetchingData: false,
          pageSize: this.getPageSize(response.data)
        });
      });
  }

  fetchQuatitativo() {
    this.setState({ fetchingQuatitativo: true });
    const { avaliacao } = this.props;

    axios
      .get(
        `${API_HOST}/avaliacoes/avaliacao/${avaliacao}/quantidade_alternativas`
      )
      .then((response) => {
        this.setState({
          quantitativoData: response.data,
          fetchingQuatitativo: false
        });
      });
  }

  exportToExcel = () => {
    let jsonArray = [];
    const { data } = this.state;
    const { nomeAvaliacao } = this.props;

    let jsonFormated = {};
    data.map((data) => {
      jsonFormated = {
        Posição: data.posicao,
        Gabarito: data.gabarito,
        Item: data.item,
        Autor: data.item_autor,
        Elaborador: data.criado_por,
        'Áreas do conhecimento': data.criado_por,
        Dificuldade: data.dificuldade,
        'Eixo/Disciplina': data.disciplina
      };
      jsonArray.push(jsonFormated);
    });

    const worksheet = XLSX.utils.json_to_sheet(jsonArray);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Gabarito');
    XLSX.writeFile(workbook, `Gabarito-${nomeAvaliacao}.xlsx`);
  };

  renderBody = () => {
    const { data, fetchingData, pageSize, quantitativoData } = this.state;

    if (fetchingData) {
      return <Loading />;
    }
    const tableData = [];
    quantitativoData &&
      quantitativoData.map((d) => {
        tableData.push([d.letra, d.quantidade, `${d.porcentagem}%`]);
        return tableData;
      });

    const columns = [
      {
        Header: 'Posição',
        accessor: 'posicao',
        width: 70
      },
      {
        Header: 'Gabarito',
        accessor: 'gabarito',
        width: 70
      },
      {
        Header: 'Situação',
        accessor: 'status',
        width: 70
      },
      {
        Header: 'Item',
        accessor: 'item',
        width: 80
      },
      {
        Header: 'Autor',
        accessor: 'item_autor',
        width: 85
      },
      {
        Header: 'Elaborador',
        accessor: 'criado_por'
      },
      {
        Header: 'Áreas do conhecimento',
        accessor: 'areas_conhecimento'
      },
      {
        Header: 'Dificuldade',
        accessor: 'dificuldade'
      },
      {
        Header: 'Eixo/Disciplina',
        accessor: 'disciplina'
      },
      {
        Header: 'Matrizes de Referência',
        accessor: 'dados_matriz.matriz'
      },
      {
        Header: `${this.shouldDisplayDefault('matriz.competencia') || 'Competência'}s`,
        accessor: 'dados_matriz.competencia'
      },
      {
        Header: `${this.shouldDisplayDefault('matriz.habilidade') || 'Habilidade'}s`,
        accessor: 'dados_matriz.habilidade'
      }
    ];

    return (
      <div style={{ padding: '0 17px' }}>
        <h5>Quantitativo das alternativas</h5>
        {get(quantitativoData, 'length') > 0 ? (
          <FormTable headers={this.headersAlternativa} data={tableData} />
        ) : (
          <span style={{ fontWeight: 600 }}>
            Este instrumento não possui Alternativas
          </span>
        )}
        <hr />
        <Table
          columns={columns}
          data={data}
          pageSize={pageSize}
          onPageSizeChange={(pageSize) => this.setState({ pageSize })}
        />
      </div>
    );
  };

  render() {
    const { toggle, isOpen, avaliacao } = this.props;

    return (
      <Modal
        filterable
        className="table-default"
        isOpen={isOpen}
        toggle={toggle}
        size="lg"
        onOpened={this.onOpened}
      >
        <ModalHeader toggle={toggle}>Itens</ModalHeader>
        <ModalBody className="bg-white pb-0">
          <div className="row">
            <div className="col-12 p-0">
              <div
                className="btn-group mt-2 mb-2 ml-3"
                role="group"
                aria-label="Actions"
              >
                <Link
                  className="btn btn-white"
                  to={`/instrumentos-cognitivos/gabarito/${avaliacao}/impressao`}
                >
                  <i className="fas fa-print" />
                </Link>
                <button
                  className="btn btn-white"
                  onClick={() => this.exportToExcel()}
                >
                  <i className="far fa-file-excel" />
                </button>
              </div>
              {this.renderBody()}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="col-4 text-right">
            <button className="btn btn-white" onClick={toggle}>
              Fechar
            </button>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}
